export enum OrderTypeCodeEnum {
	Delivery = 'DELIVERY',
	Pickup = 'PICK-UP',
}
